import { Box } from '@settled/ui'

function Logo() {
	return <Box component="img" src={require('./logo@2x.png')} sx={{ display: 'block', width: 120 }} />
}

export default Logo
